import { createApi } from '@reduxjs/toolkit/query/react';

import { ArtifactStats, ArtifactUnpacked } from '../types/artifact-types';
import { baseQueryWithErrorHandling } from './baseQuery';

interface ArtifactDetails {
  id: string;
  name: string;
  url: string;
  mime_type: string | null;
  size: number | null;
  description: string | null;
}

export const artifactApi = createApi({
  reducerPath: 'artifactApi',
  tagTypes: ['Artifact'],
  baseQuery: baseQueryWithErrorHandling,
  endpoints: (builder) => ({
    // Get all calls
    getArtifact: builder.query<
      ArtifactDetails,
      { matterId: string; artifactId: string }
    >({
      query: ({ matterId, artifactId }) =>
        `api/matters/${matterId}/artifacts/${artifactId}/`,
      providesTags: (result) =>
        result ? [{ type: 'Artifact', id: result.id }] : [],
    }),
    getArtifactUnpacked: builder.query<
      ArtifactUnpacked,
      { matterId: string; artifactId: string }
    >({
      query: ({ matterId, artifactId }) =>
        `api/matters/${matterId}/artifacts/${artifactId}/unpacked/`,
      providesTags: (result) =>
        result ? [{ type: 'Artifact', id: result.id }] : [],
    }),
    listArtifacts: builder.query<ArtifactUnpacked[], { matterId: string }>({
      query: ({ matterId }) => `api/matters/${matterId}/artifacts/`,
    }),
    getArtifactStats: builder.query<ArtifactStats, { matterId: string }>({
      query: ({ matterId }) => `api/matters/${matterId}/artifacts/stats/`,
      providesTags: (result, error, { matterId }) => [
        { type: 'Artifact', id: `stats-${matterId}` },
      ],
    }),
  }),
});

export const {
  useGetArtifactQuery,
  useGetArtifactUnpackedQuery,
  useListArtifactsQuery,
  useGetArtifactStatsQuery,
} = artifactApi;
